const configuredPath = String(process.env.REACT_APP_ADMIN_PATH || '/gestion-esganga-privado')
    .trim()
    .replace(/\/+$/, '');

export const ADMIN_PATH = configuredPath.startsWith('/') ? configuredPath : `/${configuredPath}`;
export const ADMIN_LOGIN_PATH = `${ADMIN_PATH}/login`;
export const ADMIN_CHANGE_PASSWORD_PATH = `${ADMIN_PATH}/cambiar-clave`;
export const ADMIN_RESET_PASSWORD_PATH = `${ADMIN_PATH}/restablecer-clave`;

